import type { FunctionComponent, HTMLAttributes } from "react"

import { clsx } from "clsx"

import { Check } from "@jobteaser/spark/components/Icons/Check"
import { Cross } from "@jobteaser/spark/components/Icons/Cross"

import styles from "./IconPackState.module.css"

type IconPackStateProps = {
  included: boolean
} & HTMLAttributes<HTMLDivElement>

export const IconPackState: FunctionComponent<IconPackStateProps> = ({ className, included = true, ...restProps }) => {
  const mainClassName = clsx(styles.main, className, {
    [styles["main--included"]]: included,
    [styles["main--notIncluded"]]: !included,
  })

  const IconState = included ? Check : Cross

  return (
    <div {...restProps} className={mainClassName}>
      <IconState />
    </div>
  )
}
